import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(utc);
dayjs.extend(LocalizedFormat);

export const DATE_TIME_CLIENT_FORMAT = 'DD/MM/YYYY, HH:mm';
export const DATE_TIME_CLIENT_FORMAT_WITH_SECOND = 'DD/MM/YYYY, HH:mm:ss';
export const DATE_CLIENT_FORMAT = 'DD/MM/YYYY';
const DATE_SERVER_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export const UTCToLocal = (
  utc: string | Dayjs,
  formatOutput: string,
  formatInput = DATE_SERVER_FORMAT
): string => {
  return dayjs.utc(utc, formatInput).local().format(formatOutput);
};

export const UTCToDateTime = (
  utc: string | Dayjs | undefined,
  formatInput = DATE_SERVER_FORMAT
): string => {
  if (!utc) return '';
  return dayjs.utc(utc, formatInput).local().format(DATE_TIME_CLIENT_FORMAT);
};
export const UTCToDateTimeWithSecond = (
  utc: string | Dayjs,
  formatInput = DATE_SERVER_FORMAT
): string => {
  return dayjs.utc(utc, formatInput).local().format(DATE_TIME_CLIENT_FORMAT_WITH_SECOND);
};
export const UTCToDate = (utc: string | Dayjs, formatInput = DATE_SERVER_FORMAT): string => {
  return dayjs.utc(utc, formatInput).local().format(DATE_CLIENT_FORMAT);
};

export const localToUTC = (
  local: string | Dayjs,
  formatInput = DATE_CLIENT_FORMAT,
  formatOutput = DATE_SERVER_FORMAT
): string => {
  return dayjs.utc(local, formatInput).format(formatOutput);
};

export const dateToUTC = (local: string | Dayjs): string => {
  return dayjs(local).toISOString();
};

export const localToISO8601 = (local: string | Dayjs, formatInput = DATE_CLIENT_FORMAT): string => {
  return dayjs(local, formatInput).toISOString();
};
